module.exports = __webpack_public_path__ + "img/主图.5c14eab5.webp";